import request from '../utils'

const databatchApi = {
    dataBatchList: async (dataSpaceId) => {
        const res = await request.get(`/api/dataspace/${dataSpaceId}/batches`);
        return res.body;
    },
    dataBatchDetail: async (dataSpaceId, batchId) => {
        const res = await request.get(`/api/dataspace/${dataSpaceId}/batches/${batchId}`);
        return res.body;
    },
    dataBatchCreate: async (dataSpaceId, batch) => {
        const res = await request.post(`/api/dataspace/${dataSpaceId}/batches`).send(batch);
        return res.body;
    },
    dataBatchUpdate: async (dataSpaceId, batchId, content) => {
        const res = await request.put(`/api/dataspace/${dataSpaceId}/batches/${batchId}`).send(content);
        return res.body;
    },
    dataBatchDelete: async (dataSpaceId, batchId) => {
        await request.delete(`/api/dataspace/${dataSpaceId}/batches/${batchId}`);
    },
    dataBatchRun: async (dataSpaceId, batchId,recreateTable) => {
        const res = await request.get(`/api/dataspace/${dataSpaceId}/batches/${batchId}/run?recreateTable=${recreateTable}`);
        return res.body;
    }
};

export default databatchApi